import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const handleScroll = (e, targetId) => {
    if (targetId === "top") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const element = document.getElementById(targetId);
    if (element) {
      e.preventDefault();
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-12 px-6 md:px-12 text-sm border-t-4 border-blue-700">
      <div className="max-w-7xl mx-auto">
        {/* Top SEO Keyword-Rich Paragraph */}
        <div className="mb-12 text-center md:text-left border-b border-gray-800 pb-8">
          <h2 className="text-xl font-bold text-white mb-3 tracking-wide">
            Excellent Yamaha - Authorized Yamaha Motorcycle & Scooter Dealer in Delhi NCR
          </h2>
          <p className="text-gray-400 leading-relaxed max-w-4xl">
            Welcome to <strong>Excellent Motors</strong> (Excellent Yamaha), Delhi's premier authorized channel partner for Yamaha Motor India. We offer the complete range of high-performance Yamaha motorcycles and styling city scooters at our modern showrooms in <strong>West Delhi, Pitampura, Saraswati Vihar, Paschim Vihar, Peeragarhi, and Rohini (Rithala)</strong>. Enjoy exclusive finance schemes, low down-payment options starting from ₹10,000, exchange bonuses, and certified Yamaha service and genuine accessories. Visit our showrooms today for an unmatched riding experience!
          </p>
        </div>

        {/* 4-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Column 1: Showroom Locations - Set 1 */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 border-l-4 border-yellow-500 pl-3 uppercase tracking-wider">
              Our Showrooms (West Delhi)
            </h3>
            <div className="space-y-6">
              {/* Location 1 */}
              <div>
                <h4 className="text-yellow-400 font-semibold text-sm flex items-center mb-1">
                  <i className="fa-solid fa-location-dot mr-2"></i> Pitampura / Saraswati Vihar
                </h4>
                <p className="text-gray-400 text-xs leading-normal mb-1">
                  HOUSE NO-303, Block B, Saraswati Vihar, Pitampura, New Delhi, Delhi 110034
                </p>
                <p className="text-gray-300 text-xs flex items-center">
                  <i className="fa-solid fa-phone mr-1.5 text-gray-500"></i> +91 7838736859
                </p>
                <a
                  href="https://maps.google.com/?q=HOUSE+NO-303,+Block+B,+Saraswati+Vihar,+Pitampura,+New+Delhi,+Delhi+110034"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-xs text-blue-400 hover:text-blue-300 mt-2 transition"
                >
                  <i className="fa-solid fa-map-location-dot mr-1"></i> Get Directions &rarr;
                </a>
              </div>

              {/* Location 2 */}
              <div>
                <h4 className="text-yellow-400 font-semibold text-sm flex items-center mb-1">
                  <i className="fa-solid fa-location-dot mr-2"></i> Paschim Vihar / Peeragarhi
                </h4>
                <p className="text-gray-400 text-xs leading-normal mb-1">
                  RR-11, near Peeragarhi metro station, Block A 2, Mianwali Nagar, Paschim Vihar, New Delhi, Delhi 110087
                </p>
                <p className="text-gray-300 text-xs flex items-center">
                  <i className="fa-solid fa-phone mr-1.5 text-gray-500"></i> +91 7982920138
                </p>
                <a
                  href="https://maps.google.com/?q=RR-11,+near+Peeragarhi+metro+station,+Block+A+2,+Mianwali+Nagar,+Paschim+Vihar,+New+Delhi,+Delhi+110087"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-xs text-blue-400 hover:text-blue-300 mt-2 transition"
                >
                  <i className="fa-solid fa-map-location-dot mr-1"></i> Get Directions &rarr;
                </a>
              </div>
            </div>
          </div>

          {/* Column 2: Showroom Locations - Set 2 */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 border-l-4 border-yellow-500 pl-3 uppercase tracking-wider">
              Our Showrooms (Rohini Area)
            </h3>
            <div className="space-y-6">
              {/* Location 3 */}
              <div>
                <h4 className="text-yellow-400 font-semibold text-sm flex items-center mb-1">
                  <i className="fa-solid fa-location-dot mr-2"></i> Peeragarhi Village
                </h4>
                <p className="text-gray-400 text-xs leading-normal mb-1">
                  487/37, near Sidh baba mandir, Peera Garhi, Peeragarhi Village, Paschim Vihar, New Delhi, Delhi 110087
                </p>
                <p className="text-gray-300 text-xs flex items-center">
                  <i className="fa-solid fa-phone mr-1.5 text-gray-500"></i> +91 8447347239
                </p>
                <a
                  href="https://maps.google.com/?q=487/37,+near+Sidh+baba+mandir,+Peera+Garhi,+Peeragarhi+Village,+Paschim+Vihar,+New+Delhi,+Delhi+110087"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-xs text-blue-400 hover:text-blue-300 mt-2 transition"
                >
                  <i className="fa-solid fa-map-location-dot mr-1"></i> Get Directions &rarr;
                </a>
              </div>

              {/* Location 4 */}
              <div>
                <h4 className="text-yellow-400 font-semibold text-sm flex items-center mb-1">
                  <i className="fa-solid fa-location-dot mr-2"></i> Rohini / Rithala
                </h4>
                <p className="text-gray-400 text-xs leading-normal mb-1">
                  Khasra no.-132, near devi mata mandir, Rithala Extension, Rithala, Rohini, New Delhi, Delhi 110085
                </p>
                <p className="text-gray-300 text-xs flex items-center">
                  <i className="fa-solid fa-phone mr-1.5 text-gray-500"></i> +91 8368321512
                </p>
                <a
                  href="https://maps.google.com/?q=Khasra+no.-132,+near+devi+mata+mandir,+Rithala+Extension,+Rithala,+Rohini,+New+Delhi,+Delhi+110085"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-xs text-blue-400 hover:text-blue-300 mt-2 transition"
                >
                  <i className="fa-solid fa-map-location-dot mr-1"></i> Get Directions &rarr;
                </a>
              </div>
            </div>
          </div>

          {/* Column 3: Popular Yamaha Models (Keyword Tags) */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 border-l-4 border-yellow-500 pl-3 uppercase tracking-wider">
              Popular Yamaha Models
            </h3>
            <p className="text-xs text-gray-400 mb-3 leading-normal">
              Click on a model below to explore pricing and specifications:
            </p>
            <div className="flex flex-wrap gap-2">
              <a href="https://www.yamaha-motor-india.com/yamaha-r15v4.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha R15 V4
              </a>
              <a href="https://www.yamaha-motor-india.com/yamaha-mt-15-v2.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha MT-15 V2.0
              </a>
              <a href="https://www.yamaha-motor-india.com/yamaha-fzs-fi-hybrid.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha FZ-S Fi Hybrid
              </a>
              <a href="https://www.yamaha-motor-india.com/yamaha-aerox.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha Aerox 155 S
              </a>
              <a href="https://www.yamaha-motor-india.com/yamaha-fascino125fi-new.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha Fascino 125 Fi
              </a>
              <a href="https://www.yamaha-motor-india.com/yamaha-ray-zr125fihybrid.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha RayZR 125 Fi
              </a>
              <a href="https://www.yamaha-motor-india.com/yamaha-fz-fi.html" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-gray-300 hover:bg-yellow-500 hover:text-blue-900 text-xs px-3 py-1.5 rounded-lg border border-gray-700 transition">
                Yamaha FZ-Fi Series
              </a>
            </div>
          </div>

          {/* Column 4: Quick Links & Contact Info */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 border-l-4 border-yellow-500 pl-3 uppercase tracking-wider">
              Quick Navigation
            </h3>
            <ul className="space-y-2.5 text-sm mb-6">
              <li>
                <Link to="/" onClick={(e) => handleScroll(e, "top")} className="hover:text-yellow-400 transition flex items-center">
                  <i className="fa-solid fa-angle-right text-yellow-500 mr-2 text-xs"></i> Home Page
                </Link>
              </li>
              <li>
                <Link to="/offers" onClick={(e) => handleScroll(e, "offers")} className="hover:text-yellow-400 transition flex items-center">
                  <i className="fa-solid fa-angle-right text-yellow-500 mr-2 text-xs"></i> Special Offers
                </Link>
              </li>
              <li>
                <Link to="/models" onClick={(e) => handleScroll(e, "models")} className="hover:text-yellow-400 transition flex items-center">
                  <i className="fa-solid fa-angle-right text-yellow-500 mr-2 text-xs"></i> Yamaha Models
                </Link>
              </li>
              <li>
                <Link to="/locate-us" onClick={(e) => handleScroll(e, "showroom")} className="hover:text-yellow-400 transition flex items-center">
                  <i className="fa-solid fa-angle-right text-yellow-500 mr-2 text-xs"></i> Locate Showroom
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={(e) => handleScroll(e, "contact")} className="hover:text-yellow-400 transition flex items-center">
                  <i className="fa-solid fa-angle-right text-yellow-500 mr-2 text-xs"></i> Book a Test Ride
                </Link>
              </li>
            </ul>

            <h4 className="text-white font-semibold text-xs uppercase tracking-wider mb-2">
              Support Email
            </h4>
            <a href="mailto:excellent.yamahamotors@gmail.com" className="text-blue-400 hover:text-blue-300 transition flex items-center">
              <i className="fa-solid fa-envelope mr-2"></i>excellent.yamahamotors@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>
    {/* Sleek bottom copyright bar with high contrast dark background */}
    <div className="bg-gray-950 text-gray-500 py-6 px-6 md:px-12 text-xs border-t border-gray-850">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <p>&copy; {new Date().getFullYear()} Excellent Motors. All Rights Reserved. Designed & Optimized for Yamaha Enthusiasts.</p>
        <div className="flex space-x-4 mt-4 md:mt-0">
          {/* <Link to="/contact" className="hover:underline hover:text-gray-400">Privacy Policy</Link>
          <span>|</span>
          <Link to="/contact" className="hover:underline hover:text-gray-400">Terms & Conditions</Link> */}
        </div>
      </div>
    </div>
    </>
  );
}

export default Footer;
